// @flow
import React, {PureComponent} from 'react'
import {BlokkComponent} from '../Blokk/index'

import type {Blokk} from '../Blokk/index'

import {
  enblokksvisning,
  enblokksvisning__liste as liste,
  flertall,
  flertall__tittel as tittel
} from './index.css'

type KonstellasjonslisteProps = {
  blokker: Array<Blokk>,
  headingLevel: number
}

export class Blokkliste extends PureComponent {
  props: KonstellasjonslisteProps

  render() {
    const {blokker, headingLevel} = this.props
    return (
      <div className={enblokksvisning}>
        <div className={flertall}>
          <div className={tittel} aria-hidden="true">
            Flertall
          </div>
        </div>
        <div className={liste}>
          {blokker.map(blokk =>
            <BlokkComponent
              blokk={blokk}
              key={blokk.id}
              headingLevel={headingLevel}
            />
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/enblokksvisning/Blokkliste/index.js